  <template>
  <v-dialog v-bind="$attrs" v-on="$listeners" class="dialog-wrapper">
    <!-- Pass on all named slots -->
    <slot v-for="slot in Object.keys($slots)" :name="slot" :slot="slot" />

    <!-- Pass on all scoped slots -->
    <template
      v-for="slot in Object.keys($scopedSlots)"
      :slot="slot"
      slot-scope="scope"
      ><slot :name="slot" v-bind="scope"
    /></template>
  </v-dialog>
</template>

<script>
export default {
  name: "ADialog",
  components: {},
  data() {
    return {};
  },
};
</script>

<style>
.v-application .v-toolbar.primaryLight1 {
  height: 48px !important;
  box-shadow: none !important;
}
.v-application .primaryLight1 .v-toolbar {
  height: 48px !important;
}
.v-application .primaryLight1 .v-toolbar__content {
  color: var(--v-darkCharcoal-base) !important;
  height: 48px !important;
  font-family: "Noto Sans JP" !important;
}
.v-application .primaryLight1 .v-toolbar__content span {
  font-size: 14px;
  line-height: 21px;
  font-style: normal;
  font-weight: 700;
}
.v-application .primaryLight1 .v-toolbar__content .v-icon.grey-lighten-1--text {
  color: var(--v-neutralGray-base) !important;
}
.v-application .primaryLight1 {
  color: var(--v-darkCharcoal-base) !important;
}
.v-application .v-dialog .v-card__actions {
  padding: 20px 20px;
}
.v-dialog > .v-card > .v-card__text {
    padding: 20px 20px;
}
</style>